import { createFileRoute } from '@tanstack/react-router'

import { HomePageSkeleton } from '#/modules/home/front-office/home-page/home-page-skeleton.tsx'
import { HomePage } from '#/modules/home/front-office/home-page/home-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/home-v2')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  loader: ({ context }) => {
    const { queryClient, trpc } = context
    // Fire-and-forget: these secondary blocks fetch independent, argument-free data. Warming them here
    // runs them in parallel with the two blocking queries below, instead of starting a second serial
    // network layer once HomePage mounts. Not awaited, so they never delay the first paint.
    void queryClient.prefetchQuery(trpc.invoices.hasUnpaidInvoices.queryOptions())
    void queryClient.prefetchQuery(trpc.renewal.getUserPendingRenewalsToFill.queryOptions())
    void queryClient.prefetchQuery(trpc.claims.getClaimsContactInfo.queryOptions())
    return Promise.all([
      queryClient.ensureQueryData(trpc.users.loadMyInformation.queryOptions()),
      queryClient.ensureQueryData(trpc.contracts.listMyContracts.queryOptions()),
    ])
  },
  pendingComponent: HomePageSkeleton,
  pendingMs: 150,
  component: HomePage,
})
